import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material';
import { AuthService } from 'src/app/core/auth/auth.service';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { CommonService } from 'src/app/core/services/common.service';

@Component({
  selector: 'app-select-version',
  templateUrl: './select-version.component.html',
  styleUrls: ['./select-version.component.scss']
})
export class SelectVersionComponent implements OnInit {

  vContract: any = '../../../../assets/images/select-version/vContract.png'
  sContract: any = '../../../../assets/images/select-version/sContract.png'
  urlPhoto: string = `../../../../assets/images/select-version/Check.png`
  isRemember: boolean
  chooseVersion: any
  data: any
  isNotAttestedUser = false;
  userServices = JSON.parse(localStorage.getItem('userServices') || '[]')

  constructor(
    public commonService: CommonService,
    public dialogRef: MatDialogRef<SelectVersionComponent>,
    private authService: AuthenticationService,
    private authSer: AuthService,
    @Inject(MAT_DIALOG_DATA) public dataDialog: any,
    private dialog: MatDialog,
  ) {
    this.data = dataDialog
    this.isNotAttestedUser = this.commonService.checkEnterpriseType()
    if (this.data.isLogin) {
      this.chooseVersion = 1
      return
    }
    if (this.userServices && this.userServices.length >= 2) {
      const defaultVersion = this.userServices.find(item => item.isDefault)
      if (defaultVersion) {
        this.chooseVersion = defaultVersion.scopeType
      } else {
        if (this.isNotAttestedUser) {
          this.chooseVersion = 2
        } else {
          this.chooseVersion = 1
        }
      }
    }
    // console.log('this.data', this.data)
  }

  ngOnInit() {
    // this.checkIsDefault(this.chooseVersion)
  }

  checkIsDefault(choosedVersion) {
    const objCheckDefault = this.data.userServices.find(x => x.scopeType == choosedVersion)
    this.isRemember = objCheckDefault && objCheckDefault.isDefault ? objCheckDefault.isDefault : false
  }

  chooseVersionChange() {
    // this.checkIsDefault(this.chooseVersion)
  }

  onNoClick() {
    this.dialogRef.close();
  }

  onClickBtnConfirm() {
    let scopeTypeChoose = this.data.userServices.find(x => x.scopeType == this.chooseVersion)
    const dataUpdate = {
      id: scopeTypeChoose ? scopeTypeChoose.id : '',
      isDefault: !this.data.isLogin ? true : this.isRemember ? this.isRemember : null
    }
    this.authService.changeMode(dataUpdate).subscribe(result => {
      if (result && result.success) {
        localStorage.setItem("permissions", JSON.stringify(result.data.permissions));
        localStorage.setItem('isParent', result.data.isParent);
        localStorage.setItem('isAdminDefault', result.data.isAdminDefault);
        localStorage.setItem('userType', result.data.userType);
        localStorage.setItem('isLocked', result.data.isLocked);
      }
      if (result) this.dialogRef.close(result);
    })
  }
}
